"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequest = void 0;
const tslib_1 = require("tslib");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const HTTPResponse_1 = require("./HTTPResponse");
class HTTPRequest {
    constructor(baseURL) {
        this.baseURL = baseURL;
        this.headers = {};
        this.timeout = 10000000;
        this.params = {};
        this.requestDetails = () => ({
            baseURL: this.baseURL,
            path: this.path,
            method: this.method,
            data: this.data,
        });
        this.fetch = async () => {
            const { baseURL, params, timeout, path, data, headers, method } = this;
            return await (0, axios_1.default)({
                ...(data ? { data } : {}),
                url: path,
                transformResponse: (r) => r,
                baseURL,
                method,
                headers,
                timeout,
                validateStatus: () => true,
                params,
            });
        };
    }
    static for(baseURL) {
        return new HTTPRequest(baseURL);
    }
    timeoutInMS(ms) {
        this.timeout = ms;
        return this;
    }
    to(path) {
        this.path = path;
        return this;
    }
    optionalParams(params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined) {
                this.param(key, value);
            }
        });
        return this;
    }
    param(key, value) {
        if (Array.isArray(value)) {
            this.params[key] = JSON.stringify(value);
        }
        else {
            this.params[key] = `${value}`;
        }
        return this;
    }
    header(key, value) {
        this.headers[key] = value;
        return this;
    }
    bodyString(body) {
        this.data = body;
        this.header('content-type', 'text/plain');
        return this;
    }
    bodyEmpty() {
        this.data = undefined;
        return this;
    }
    bodyJSON(body) {
        if (body?.asJSON) {
            this.data = JSON.stringify(body.asJSON());
        }
        else {
            this.data = JSON.stringify(body);
        }
        this.header('content-type', 'application/json');
        return this;
    }
    bearerToken(token) {
        this.header('Authorization', `Bearer ${token}`);
        return this;
    }
    apiKey(key) {
        this.header('X-API-Key', `${key}`);
        return this;
    }
    async get(deserializer) {
        this.method = 'get';
        return HTTPResponse_1.HTTPResponse.handle(this, deserializer);
    }
    async post(deserializer) {
        this.method = 'post';
        return HTTPResponse_1.HTTPResponse.handle(this, deserializer);
    }
    async put(deserializer) {
        this.method = 'put';
        return HTTPResponse_1.HTTPResponse.handle(this, deserializer);
    }
    async delete(deserializer) {
        this.method = 'delete';
        return HTTPResponse_1.HTTPResponse.handle(this, deserializer);
    }
}
exports.HTTPRequest = HTTPRequest;
